export const MODEL_ROUTE = '/prescriptions';
